import { render, staticRenderFns } from "./temp_uni.vue?vue&type=template&id=66d52f5d&"
import script from "./temp_uni.vue?vue&type=script&lang=js&"
export * from "./temp_uni.vue?vue&type=script&lang=js&"
import style0 from "./temp_uni.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports